import { render, staticRenderFns } from "./Catalogs.html?vue&type=template&id=02ddcdec&scoped=true&external"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"
import style0 from "./Catalogs.scss?vue&type=style&index=0&id=02ddcdec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddcdec",
  null
  
)

export default component.exports